import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { ModalComponent } from '../../../../../vass-core/components/modal/modal.component';

@Component({
  selector: 'app-incorrect-data-modal',
  templateUrl: './incorrect-data-modal.component.html',
  styleUrls: ['./incorrect-data-modal.component.scss'],
  standalone: false,
})
export class IncorrectDataModalComponent implements OnInit {
  public commentInput: UntypedFormControl;
  public message: string;
  public maxComment: number = 500;
  public showConform = false;

  constructor(public modalComponent: ModalComponent) {
    if (this.modalComponent.data.type === 'deleteData') {
      this.message = 'incorrec-data-model-delete';
    } else {
      this.message = 'incorrec-data-model-edit';
    }
  }

  ngOnInit() {
    this.commentInput = new UntypedFormControl('', [
      Validators.maxLength(this.maxComment),
    ]);
  }

  sendForm() {
    if (this.commentInput.valid) {
      this.modalComponent.sendDataFromModal({
        ref: this.modalComponent,
        data: this.commentInput.value,
      });
    }
  }
}
